<template>
<div id="contentlist">
  <!-- <el-row v-for="(item, index) in newsdata" :key="item.id" >
      <el-col :span="24" class="el-item">

          <div class="news-box">
            <a href="javascript:void(0)" @click="goUrl(item)">
              <div class="box-header">
                  <span class="new-type">{{item.category}}</span>
                  <span class="hot-level">HOT {{item.hotindex}}</span>
              </div>
              <div class="box-title">
                  <h2>{{item.title}}</h2>
              </div>
              <div class="box-content">
                  <img class="box-image" :src="item.cover" v-if="item.cover"/>
                  <p class="box-text">{{item.content}}</p>
              </div>
              <div class="box-foot">
                  <div v-for="(lable, index) in item.labels" :key="index">
                      <span v-if="index === 0">{{lable}}</span>
                      <span v-else>&nbsp;/ {{lable}}</span>
                  </div>
              </div>
            </a>
          </div>
      </el-col>
  </el-row> -->

  <el-row type="flex" justify="center" v-for="(item, index) in newsdata" :key="item.id">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item">
          <div class="box shadow">
              <div class="box-record-label" v-if="labelname === '录音已上传' && item.mediaurl">
                <span class="box-label-text">{{labelname}}</span>
              </div>
              <div class="box-audit-label" v-else-if="labelname === '已修改' && item.tip">
                <span class="box-label-text">{{labelname}}</span>
              </div>
              <div class="news-box">
                <!-- <a href="javascript:void(0)" @click="goUrl(item)"> -->
                <!-- <router-link :to="{ path: linkpath, query: { id: item.id }}" @click.native="handleClick(item)"> -->
                
                  <div class="box-header fs-catego">
                      <span class="new-type">{{item.scenario}}</span>
                      <span class="hot-level">{{item.rating}}</span>
                  </div>
                  <div class="box-title">
                    <h1 class="fs-title">{{item.title}}</h1>
                  </div>
                  <div class="box-date fs-label">
                    <!-- <span >{{item.date}}</span> -->
                    <!-- <span v-if="item.category"><b>{{item.state}}</b> </span> -->
                    <span v-if="item.author">作者:{{item.author}}</span>
                    <span v-if="item.auditor"> 审核:{{item.auditor}}</span>
                    <!-- <p><span>dat:{{item.date}}</span><span> edi:{{item.edittime}}</span><span> hos:{{item.hosttime}}</span><span> val:{{item.verifiertime}}</span><span> pub:{{item.publish_time}}</span></p> -->
                  </div>
                  <div class="box-content">
                      <p class="box-text fs-text">{{item.content}}</p>
                  </div>
                  <audio :src="item.url" controls="controls">
                    您的浏览器暂不支持H5音频播放，请升级浏览器
                  </audio>
                  <div class="box-foot">
                      <div class="host-name">
                       <!--  <span class="fs-label" v-if="item.rating"><b>{{item.rating}}</b> </span> -->
                        <!-- <span v-if="item.editorname">编:{{item.editorname}}</span>
                        <span v-if="item.hostname"> 播:{{item.hostname}}</span>
                        <span v-else-if="item.host"> 播:{{item.host}}</span>
                        <span v-if="item.verifiername"> 审:{{item.verifiername}}</span> -->
                      </div>
                      <div class="foot-label fs-label">
                        <span v-for="(lable, index) in item.tags" :key="index">
                            <span v-if="index === 0">{{lable}}</span>
                            <span v-else>&nbsp;/ {{lable}}</span>
                        </span>
                      </div>
                  </div>
                  <div class="box-edit-tag">
                    <router-link :to="{ name: urladdr, query: {id:item._id, index:index} }">
                      <i class="el-icon-edit"></i> 编辑
                    </router-link>
                  </div>
                  <div class="box-tag" v-show="tipshow && item.tip">
                      <img src="../../static/img/ibroadcast/bohui.png"/>
                  </div>
                
                <!-- </a> -->
              </div>
          </div>
      </el-col>
  </el-row>

  <!-- <span class="nav-pagin" >
    <el-pagination layout="total, prev, pager, next, jumper" @current-change="handlePageChange" :page-size="limit" :total="total">
    </el-pagination>
  </span> -->
</div>
</template>
<script>
import '../../static/style/common/contentlist.scss'
import {mapGetters, mapActions} from 'vuex';

export default {
    model: {
      prop: ['newsdata', 'labelname', 'tipshow', 'goUrl', 'limit', 'total', 'handlePageChange', 'urladdr'],
    },
    props: {
      newsdata: Array,
      labelname: String,
      tipshow: Boolean,
      goUrl: Function,
      limit: Number,
      total: Number,
      handlePageChange: Function,
      urladdr: String,
    },
    data: () => ({

    }),
    created() {
        // console.debug("created> newsdata:%o, labelname:%o, tipshow:%o, goUrl:%o, limit:%o, total:%o, handlePageChange:%o, urladdr:%o", this.newsdata, this.labelname, this.tipshow, this.goUrl, this.limit, this.total, this.handlePageChange, this.urladdr);
    },
    mounted() {
        // console.debug("mounted> handlePageChange:%o", this.handlePageChange);
    },
    computed: {
        ...mapGetters({
            // 映射 this.getLoadingStatus 为 store.getters.getLoadingStatus
        })
    },
    methods: {
        ...mapActions({
          // 映射 this.updateLoadingStatus() 为 this.$store.dispatch('updateLoadingStatus')
        })
    }
}
</script>
<style scoped>
/* @media (max-width: 767px) {
	#contentlist .box-content p{
		font-size:2rem; 
	}
} */
</style>




// WEBPACK FOOTER //
// src/components/common/contentlist.vue